"use client";

import { useEffect, useState } from "react";
import { jumpToAppStore } from "@/utils/tenjin";
import { isMobile } from "@/utils/is";
import DownloadPageContent from "@/app/(routeLayout)/download/content";

export default function AutoJumpHandler() {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const autoJump = urlParams.get("auto_jump");

    if (autoJump === "1") {
      const mobile = isMobile() ?? false;
      if (mobile) {
        jumpToAppStore();
      }
    } else {
      setShouldRender(true);
    }
  }, []);

  if (!shouldRender) {
    return null;
  }

  return <DownloadPageContent />;
}
